// DSL "Success 2": white disc with the tick punched out (evenodd), so the tick
// reads in the track colour. Replaces the retired Lottie; fade handled in CSS.
export default function SuccessCheckmark() {
  return (
    <svg viewBox="0 0 40 40" width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        d="M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0Zm8.06 15.06a1.5 1.5 0 0 0-2.12-2.12l-8.44 8.44-3.44-3.44a1.5 1.5 0 0 0-2.12 2.12l4.5 4.5a1.5 1.5 0 0 0 2.12 0l9.5-9.5Z"
      />
    </svg>
  )
}
